import mutations from './finalExaminationResult.mutations'
import actions from './finalExaminationResult.actions'
import getters from './finalExaminationResult.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
